import React from 'react';
import {formatNumber} from 'helpers/utils'
import PropTypes from 'prop-types';

const NumberV2Renderer = (props) => {
  if (props.value == null || Number(props.value) === 0) {
    return <span className="tw-text-right tw-text-slate-500">-</span>;
  }

   const numericValue = typeof props.value === 'string' ? parseFloat(props.value) : props.value;

  // Check if it's a valid number
  if (isNaN(numericValue)) {
    return <span className="tw-text-right tw-text-slate-500">-</span>;
  }

  const formattedValue = formatNumber(numericValue);

  return (
    <span className={`tw-text-right ${numericValue < 0 ? 'tw-text-red-600' : 'tw-text-blue-600'}`}>
      {formattedValue}
    </span>
  );
};

NumberV2Renderer.propTypes = {
  value: PropTypes.number
};

export default NumberV2Renderer;
